import { ChatType } from "../types/chatTypes";
import {
  ChatInboxConfig,
  ChatBoxConfig,
  CHAT_INBOX_CONFIGS,
  CHAT_BOX_CONFIGS,
} from "../types/chatConfigs";
import { CHAT_THEME } from "../constants/chatTheme";

export const createChatInboxConfig = (
  chatType: ChatType,
  position: "left" | "right",
  behavior: {
    onChatClick: (uniqueName: string, conversation?: any) => Promise<void>;
    getParticipantName: (chat: any) => Promise<string>;
    getParticipantId: (chat: any) => string;
  }
): ChatInboxConfig => {
  const baseConfig = CHAT_INBOX_CONFIGS[chatType];

  return {
    chatType,
    position,
    styles: baseConfig.styles,
    content: baseConfig.content,
    behavior,
  };
};

export const createChatBoxConfig = (
  chatType: ChatType,
  positioning: {
    getPosition: () => string;
    getSide: () => "left" | "right";
  }
): ChatBoxConfig => {
  const baseConfig = CHAT_BOX_CONFIGS[chatType];

  return {
    chatType,
    styles: baseConfig.styles,
    content: baseConfig.content,
    positioning,
  };
};

export const POSITIONING_CONFIGS = {
  customer: {
    getPosition: () => CHAT_THEME.POSITIONS.CHAT_OFFSET,
    getSide: () => "left" as const,
  },
  supplier: {
    getPosition: () => CHAT_THEME.POSITIONS.CHAT_OFFSET,
    getSide: () => "right" as const,
  },
};
